// App version

const _APP_VERSION_RAW = "2.2.8";
export const APP_VERSION = _APP_VERSION_RAW.startsWith("${") ? "v1.1" : _APP_VERSION_RAW;

// App environment (DEV | TST | UAT | PRO)
// Injected at container startup by envsubst (see runtime.vars + run.sh).
// - Local dev (no envsubst pass): falls back to "LOCAL" so the banner still appears.
// - Misconfigured deploy (var unset in K8s): falls back to "PRO" so no decoration
//   leaks into a customer-facing environment.

const _APP_ENV_RAW = "UAT";
const _ALLOWED_ENVS = ["DEV", "TST", "UAT", "PRO", "LOCAL"];
export const APP_ENV = (() => {
  if (_APP_ENV_RAW.startsWith("${")) return "LOCAL";
  const upper = _APP_ENV_RAW.toUpperCase();
  return _ALLOWED_ENVS.includes(upper) ? upper : "PRO";
})();

// General ENV

export const APP_PATH = "/";

export const BASE_URI = "https://rinf.uat.data.test-era.europa.eu";
export const API_URI = BASE_URI;
export const API_BASE_URL = BASE_URI + "/api/v1";
export const SPARQL_ENDPOINT = "https://graph.uat.data.test-era.europa.eu/repositories/rinf-plus";
export const SPARQL_ENDPOINT_PUB = "https://graph.uat.data.test-era.europa.eu/repositories/rinf-plus";
export const NAV_ENABLED_APPS = "eyJjb21wb25lbnRzIjpbImVyYS1zZWFyY2giLCJlcmEtY29tcGF0aWJpbGl0eS1jaGVjayIsImVyYS1tYXAtZXhwbG9yZXIiLCJlcmEtbm90aWZpY2F0aW9ucyIsImVyYS1kYXRhc2V0LW1hbmFnZXIiLCJlcmEtZW5kcG9pbnQiLCJlcmEtZGF0YXN0b3JpZXMiLCJlcmEtdm9jYWJ1bGFyeSIsImVyYS1kYXRhc2V0LWV4cGxvcmVyIl0sImV4dHJhcyI6WyJ1c2VyTG9naW4iXX0=";

export const NAMED_KG_RINF = "http://data.europa.eu/949/graph/rinf-plus";
export const NAMED_KG_ERATV = "http://data.europa.eu/949/graph/eratv";
export const NAMED_KG_ERA_VOCABULARY = "http://data.europa.eu/949/graph/ontology";
export const NAMED_KG_ERA_SKOS = "http://data.europa.eu/949/graph/skos";
export const NAMED_KG_ERA_SHACL = "http://data.europa.eu/949/graph/shacl";

export const DATABASE_DOMAIN = "${DATABASE_DOMAIN}";

// RCC

export const ZOOM = "12";

export const ROUTER_API = API_URI + "/api/route/calculate";
export const SEARCH_HINT_API = API_URI + "/api/v1/rcc/search";
export const CHECKS_API = API_URI + "/api/checks/execute/full";

// Search

export const RINF_GRAPH = "http://data.europa.eu/949/graph/rinf";

export const DESCRIBE_URI = SPARQL_ENDPOINT.replace(
  "/sparql",
  "/describe/?url="
);

export const ERA_ONTOLOGY = API_URI + "/era-vocabulary/ontology.ttl";
export const ERA_TYPES = API_URI + "/era-vocabulary/era-skos";

// Map Explorer

// Notifications

export const NOTIFICATIONS_SEARCH_HINT_API =
  API_BASE_URL + "/notifications/search/hints";
export const NOTIFICATIONS_API_URI = API_BASE_URL + "/notifications/";

// Dataset manager

export const API_ENDPOINT = API_URI + "/api";

// Drafts editor — name of the GraphDB repo that holds per-draft named graphs.
// Mirrors the backend env var. The backend SPARQL proxy routes `?mode=draft-only`
// to this repo, so the frontend only scopes reads to the draft's named graph
// (see utils/wrapQueryForDraft) and no longer needs the repo name for federation.
export const GRAPH_DB_DRAFT_REPOSITORY = "${GRAPH_DB_DRAFT_REPOSITORY}".startsWith(
  "${"
)
  ? "draft"
  : "${GRAPH_DB_DRAFT_REPOSITORY}";

// Azure

export const RINF_API_APP_ID_URI = "api://e397e958-09cd-451f-a917-4ec7ffccced1";
export const CLIENT_ID = "e397e958-09cd-451f-a917-4ec7ffccced1";
export const TENANT_ID = "25faedbb-f440-4315-83ee-6f7beb5e73f7";
export const REDIRECT_URI = BASE_URI;
